import { fetchWrapper, objectToQueryParams } from '../utils';

const baseUrl = process.env.REACT_APP_BASE_API + 'general';

export const getBanks = async () => {
  const url = `${baseUrl}/banks`;
  return await fetchWrapper.get(url);
}

export const getConversion = async () => {
  const url = `${baseUrl}/conversion`;
  return await fetchWrapper.get(url);
}

export const createConversion = async (form) => {
  const url = `${baseUrl}/conversion`;
  return await fetchWrapper.post(url, form);
}

export const getDocumentTypes = async () => {
  const url = `${baseUrl}/document-types`;
  return await fetchWrapper.get(url);
}

export const getPaymentMethodInfo = async (id) => {
  const url = `${baseUrl}/payment-method-info/${id}`;
  return await fetchWrapper.get(url);
}

export const getPhoneCodes = async () => {
  const url = `${baseUrl}/phone-codes`;
  return await fetchWrapper.get(url);
}

export const getStates = async () => {
  const url = `${baseUrl}/states`;
  return await fetchWrapper.get(url);
}

export const getTownships = async (filters) => {
  const url = `${baseUrl}/townships?${objectToQueryParams(filters)}`;
  return await fetchWrapper.get(url);
}

export const getParishes = async (filters) => {
  const url = `${baseUrl}/parishes?${objectToQueryParams(filters)}`;
  return await fetchWrapper.get(url);
}

export const getMeasuringUnits = async () => {
  const url = `${baseUrl}/measuring-unit`;
  return await fetchWrapper.get(url);
}

export const getSuppliers = async () => {
  const url = `${baseUrl}/suppliers`;
  return await fetchWrapper.get(url);
}

export const setSupplier = async (form) => {
  const url = `${baseUrl}/suppliers`;
  return await fetchWrapper.post(url, form);
}

export const getSupplies = async () => {
  const url = `${baseUrl}/supplies`;
  return await fetchWrapper.get(url);
}

export const setSupply = async (form) => {
  const url = `${baseUrl}/supplies`;
  return await fetchWrapper.post(url, form);
}
